"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KEY_CODE_ALT = exports.KEY_CODE_CTRL = exports.KEY_CODE_SHIFT = exports.KEY_CODE_BACKSPACE = exports.KEY_CODE_SUBMIT = exports.KEY_CODE_ESC = exports.KEY_CODE_DOWN = exports.KEY_CODE_UP = void 0;
var KEY_CODE_UP = 38;
exports.KEY_CODE_UP = KEY_CODE_UP;
var KEY_CODE_DOWN = 40;
exports.KEY_CODE_DOWN = KEY_CODE_DOWN;
var KEY_CODE_ESC = 27;
exports.KEY_CODE_ESC = KEY_CODE_ESC;
var KEY_CODE_SUBMIT = 13;
exports.KEY_CODE_SUBMIT = KEY_CODE_SUBMIT;
var KEY_CODE_BACKSPACE = 8;
exports.KEY_CODE_BACKSPACE = KEY_CODE_BACKSPACE;
var KEY_CODE_SHIFT = 16;
exports.KEY_CODE_SHIFT = KEY_CODE_SHIFT;
var KEY_CODE_CTRL = 17;
exports.KEY_CODE_CTRL = KEY_CODE_CTRL;
var KEY_CODE_ALT = 18;
exports.KEY_CODE_ALT = KEY_CODE_ALT;